import React, { useContext, useEffect, useState } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import PageTransitionLink from '../PageTransitionLink'
import Container from '../Container'
import {
  HeaderContainer,
  HeaderMain,
  Menu,
  MenuItem,
  MobileMenu,
  MobileMenuEmail,
  MobileMenuItem,
  MobileMenuItemBorder,
  MobileMenuLink,
  MobileMenuText,
  MobileNav,
  MobileNavBackground,
  MobileNavMain,
  DropdownButton,
  DropdownMenu,
  DropdownMenuItem,
  PrimaryNav,
  SecondaryNav,
} from './index.style'
import Logo from '../svgs/Logo'
import { StoreDispatch, StoreState } from '../../Store'
import { colors } from '../../styles/vars/colors.style'
import MenuToggle from '../MenuToggle'
import IconArrowRight from '../svgs/IconArrowRight'

const Header = ({ pathname }) => {
  const store = useContext(StoreState)
  const dispatch = useContext(StoreDispatch)
  const { mobileNavIsOpen } = store
  const {
    site: {
      siteMetadata: { routes, siteLocale },
    },
    contentfulHeader: {
      loginLabelText,
      loginUrl,
      presenterUrl,
      productDropdown,
    },
    contentfulFooter: { contactEmailAddress },
    contentfulHowItWorks: { seoTitle: howItWorksTitle },
    contentfulOurStory: { seoTitle: ourStoryTitle },
    contentfulAcademy: { seoTitle: academyTitle },
    contentfulCompare: { seoTitle: compareTitle },
    contentfulSuccessStories: { seoTitle: successStoriesTitle },
    contentfulContact: { seoTitle: contactTitle },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteLocale
          routes {
            home
            howItWorks
            ourStory
            academy
            compare
            successStories
            contact
            helpfulVideos
            privacyPolicy
            styleguide
          }
        }
      }
      contentfulHeader {
        loginLabelText
        loginUrl
        presenterUrl
        productDropdown
      }
      contentfulFooter {
        contactEmailAddress
      }
      contentfulHowItWorks {
        seoTitle
      }
      contentfulOurStory {
        seoTitle
      }
      contentfulAcademy {
        seoTitle
      }
      contentfulCompare {
        seoTitle
      }
      contentfulSuccessStories {
        seoTitle
      }
      contentfulContact {
        seoTitle
      }
    }
  `)
  const mainMenuItems = [
    {
      title: howItWorksTitle,
      to: routes.howItWorks,
    },
    {
      title: ourStoryTitle,
      to: routes.ourStory,
    },
    {
      title: compareTitle,
      to: routes.compare,
    },
    {
      title: successStoriesTitle,
      to: routes.successStories,
    },
    {
      title: 'Presenter',
      url: presenterUrl,
    },
  ]

  const secondaryMenuItems = [
    {
      title: loginLabelText,
      to: process.env.GATSBY_LOGIN_URL || loginUrl,
      external: true,
    },
    {
      title: contactTitle,
      to: routes.contact,
    },
  ]

  const showProductDropdown = siteLocale === 'en-US' && productDropdown

  const productMenuItems = [
    {
      title: 'Crown',
      url: 'https://www.firstfitcrown.com',
    },
    {
      title: 'Veneers',
      to: routes.howItWorks,
    },
    {
      title: 'Bridge',
      to: routes.howItWorks,
    },
    {
      title: 'Inlays/Onlays',
      to: routes.howItWorks,
    },
    {
      title: 'IPR',
      url: 'https://www.viax3d.com',
    },
  ]

  useEffect(() => {
    if (
      pathname === routes.home ||
      // pathname.includes(routes.academy) ||
      pathname.includes(routes.successStories)
    ) {
      dispatch({ type: 'SET_HEADER_LIGHT' })
    } else {
      dispatch({ type: 'SET_HEADER_DARK' })
    }
  }, [dispatch, pathname, routes])

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false)

  useEffect(() => {
    if (!store.mobileNavIsOpen) {
      setMobileDropdownOpen(false)
    }
  }, [setMobileDropdownOpen, store.mobileNavIsOpen])

  return (
    <HeaderContainer light={store.mobileNavIsOpen || store.headerIsLight}>
      <Container fullWidth allowOverflow>
        <HeaderMain>
          <PageTransitionLink to={routes.home}>
            <Logo
              fill={
                store.headerIsLight || store.mobileNavIsOpen
                  ? colors.lightGrey
                  : colors.blue
              }
            />
          </PageTransitionLink>

          <MenuToggle light={store.headerIsLight} />

          <PrimaryNav>
            <Menu>
              {React.Children.toArray(
                mainMenuItems.map((navItem, index) => (
                  <>
                    <MenuItem
                      light={store.mobileNavIsOpen || store.headerIsLight}
                      active={
                        store.pathname && navItem.to
                          ? store.pathname.indexOf(navItem.to) > -1
                          : navItem.to
                          ? pathname.indexOf(navItem.to) > -1
                          : false
                      }
                    >
                      {navItem.to ? (
                        <PageTransitionLink to={navItem.to}>
                          {navItem.title}
                        </PageTransitionLink>
                      ) : navItem.url ? (
                        <a href={navItem.url} target="_blank" rel="noreferrer">
                          {navItem.title}
                        </a>
                      ) : (
                        ``
                      )}
                    </MenuItem>
                    {index === 1 && showProductDropdown && (
                      <MenuItem
                        light={store.mobileNavIsOpen || store.headerIsLight}
                        active={false}
                        onFocus={() => setDropdownOpen(true)}
                        onBlur={() => setDropdownOpen(false)}
                        onMouseEnter={() => setDropdownOpen(true)}
                        onMouseLeave={() => setDropdownOpen(false)}
                      >
                        <DropdownButton
                          open={dropdownOpen}
                          light={store.mobileNavIsOpen || store.headerIsLight}
                        >
                          Our Products
                        </DropdownButton>
                        <DropdownMenu open={dropdownOpen}>
                          {productMenuItems.map(productItem => (
                            <DropdownMenuItem key={productItem.title}>
                              {productItem.to ? (
                                <PageTransitionLink to={productItem.to}>
                                  {productItem.title}
                                </PageTransitionLink>
                              ) : productItem.url ? (
                                <a
                                  href={productItem.url}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {productItem.title}
                                </a>
                              ) : (
                                ``
                              )}
                            </DropdownMenuItem>
                          ))}
                        </DropdownMenu>
                      </MenuItem>
                    )}
                  </>
                ))
              )}
            </Menu>
          </PrimaryNav>

          <SecondaryNav light={store.headerIsLight}>
            <Menu>
              {React.Children.toArray(
                secondaryMenuItems.map(item => (
                  <MenuItem
                    light={store.mobileNavIsOpen || store.headerIsLight}
                  >
                    {item.external ? (
                      <a href={item.to} target="_blank" rel="noreferrer">
                        {item.title}
                      </a>
                    ) : (
                      <PageTransitionLink to={item.to}>
                        {item.title}
                      </PageTransitionLink>
                    )}
                  </MenuItem>
                ))
              )}
            </Menu>
          </SecondaryNav>
        </HeaderMain>
      </Container>

      <MobileNav open={mobileNavIsOpen}>
        <MobileNavBackground />

        <MobileNavMain>
          <Container>
            <MobileMenu open={!mobileDropdownOpen}>
              {React.Children.toArray(
                mainMenuItems.map((item, index) => {
                  return (
                    <>
                      {item.to || item.url ? (
                        <MobileMenuItem
                          active={
                            store.pathname && item.to
                              ? store.pathname.indexOf(item.to) > -1
                              : item.to
                              ? pathname.indexOf(item.to) > -1
                              : false
                          }
                        >
                          {item.to ? (
                            <PageTransitionLink to={item.to}>
                              <MobileMenuText>{item.title}</MobileMenuText>
                            </PageTransitionLink>
                          ) : item.url ? (
                            <a href={item.url} target="_blank" rel="noreferrer">
                              <MobileMenuText>{item.title}</MobileMenuText>
                            </a>
                          ) : (
                            ``
                          )}
                          <IconArrowRight />
                          <MobileMenuItemBorder />
                        </MobileMenuItem>
                      ) : (
                        ``
                      )}
                      {index === 1 && showProductDropdown ? (
                        <MobileMenuItem active={false}>
                          <a
                            href="#"
                            onClick={e => {
                              e.preventDefault()
                              setMobileDropdownOpen(true)
                            }}
                          >
                            <MobileMenuText>Our Products</MobileMenuText>
                          </a>
                          <IconArrowRight />
                          <MobileMenuItemBorder />
                        </MobileMenuItem>
                      ) : (
                        ``
                      )}
                    </>
                  )
                })
              )}
              {React.Children.toArray(
                secondaryMenuItems.map((item, itemIndex) => (
                  <MobileMenuItem
                    active={
                      store.pathname
                        ? store.pathname.indexOf(item.to) > -1
                        : pathname.indexOf(item.to) > -1
                    }
                  >
                    {item.external ? (
                      <MobileMenuLink href={item.to}>
                        <MobileMenuText>{item.title}</MobileMenuText>
                      </MobileMenuLink>
                    ) : (
                      <PageTransitionLink to={item.to}>
                        <MobileMenuLink as="span">
                          <MobileMenuText>{item.title}</MobileMenuText>
                        </MobileMenuLink>
                      </PageTransitionLink>
                    )}

                    <IconArrowRight />

                    {itemIndex < secondaryMenuItems.length - 1 && (
                      <MobileMenuItemBorder />
                    )}
                  </MobileMenuItem>
                ))
              )}
            </MobileMenu>
            {showProductDropdown && (
              <MobileMenu open={mobileDropdownOpen}>
                {React.Children.toArray(
                  productMenuItems.map(item =>
                    item.to || item.url ? (
                      <MobileMenuItem active={false}>
                        {item.to ? (
                          <PageTransitionLink to={item.to}>
                            <MobileMenuText>{item.title}</MobileMenuText>
                          </PageTransitionLink>
                        ) : item.url ? (
                          <a href={item.url} target="_blank" rel="noreferrer">
                            <MobileMenuText>{item.title}</MobileMenuText>
                          </a>
                        ) : (
                          ``
                        )}
                        <IconArrowRight />
                        <MobileMenuItemBorder />
                      </MobileMenuItem>
                    ) : (
                      ``
                    )
                  )
                )}
                <MobileMenuItem active={false} close={true}>
                  <a
                    href="#"
                    onClick={e => {
                      e.preventDefault()
                      setMobileDropdownOpen(false)
                    }}
                  >
                    <MobileMenuText>Close</MobileMenuText>
                  </a>
                  <MobileMenuItemBorder />
                </MobileMenuItem>
              </MobileMenu>
            )}
          </Container>
        </MobileNavMain>

        <MobileMenuEmail href={`mailto:${contactEmailAddress}`}>
          {contactEmailAddress}
        </MobileMenuEmail>
      </MobileNav>
    </HeaderContainer>
  )
}

export default Header
